import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function Events() {
  const navigate = useNavigate();

  useEffect(() => {
    // Scroll to the top when the route changes
    window.scrollTo(0, 0);
  }, []);

  const events = [
    {
      id: 1,
      name: "Sihah convecation",
      description: "Memories from the beautiful Sihah convecation event.",
      image: "/assets/gallery/Sihah%20convecation/111.jpeg",
    },
    {
      id: 2,
      name: "Masjid inauguration",
      description: "Glimpses of our grand Masjid inauguration ceremony.",
      image:
        "/assets/gallery/Masjid%20inauguration/WhatsApp%20Image%202026-02-23%20at%203.30.53%20PM%20(1).jpeg",
    },
    {
      id: 3,
      name: "Imlaa'",
      description: "Highlights from the Imlaa' gathering.",
      image:
        "/assets/gallery/Imlaa'/WhatsApp%20Image%202026-02-23%20at%203.31.17%20PM.jpeg",
    },
    {
      id: 4,
      name: "Hadees seminar",
      description:
        "This is the second event. here is the information about data science in the growth current world",
      image: "/assets/events/hadees seminar.jpeg",
    },
    {
      id: 5,
      name: "AL BIDAYA",
      description: "Highlights from the AL BIDAYA event.",
      image:
        "/assets/gallery/AL BIDAYA/WhatsApp Image 2026-03-04 at 3.14.54 PM (2).jpeg",
    },
    {
      id: 6,
      name: "Qhathmul bukhari majlis",
      description: "Highlights from the Qhathmul bukhari majlis.",
      image:
        "/assets/gallery/Qhathmul bukhari majlis/4.jpeg",
    },
  ];

  const handleChange = (data) => {
    // navigate(`/events/${data}`)
    navigate(`/events-details/${data}`);
  };

  return (
    <>
      <div className="relative">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10 py-5 ">
          {events.map((event) => (
            <div
              key={event.id}
              onClick={() => handleChange(event.id.toString())}
              className="bg-white hover:scale-[0.95] z-40 cursor-pointer transition-all shadow-2xl rounded-lg overflow-hidden border border-gray-200"
            >
              <img
                src={event.image}
                alt={event.name}
                className="w-full h-52 object-cover"
                loading="lazy"
              />
              <div className="p-4">
                <h3 className="text-lg font-semibold text-gray-800 text-start font-AndoraModernSerif">
                  {event.name}
                </h3>
                <p className="text-gray-600 mt-2 text-sm text-start ">
                  {event.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
